/**
 *
 * Asynchronously loads the component for Login
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LoginForm = lazyLoad(
  () => import('./index'),
  module => module.LoginForm,
);
